/**
 * Main entry point used by web pack in gulp
 *  - Require any other components using require in here
 *
 * Example of local standalone scripts:
 *  require('./jquery/components/test.js');
 * Examples of node module:
 *  require('bootstrap');
 */

// TODO: FED-17 Backlog: MR4 Check polyfills following babel/webpack improvements
// require('intersection-observer');
// require('./components/utils');
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import 'regenerator-runtime/runtime';

if (!__PROD__) {
  require('jquery-migrate');
}

// NPM Dependencies
require('jquery-ui/ui/widgets/accordion');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/selectmenu');
require('jquery-ui/ui/widgets/tabs');
require('bootstrap/js/src/util');
require('bootstrap/js/src/button');
require('bootstrap/js/src/collapse');
require('bootstrap/js/src/modal');
require('bootstrap/js/src/tab');
require('bootstrap/js/src/tooltip'); // TODO: FED-031 - Test if tooltip is used

require('jquery-match-height');
require('swipeboxjq3');
require('jquery-validation');
require('jquery-validation-unobtrusive');

// JCB modules
require('./components/compareRange');
require('./components/dropdown-anchor');
require('./components/heroCarousel');
require('./components/industryCookie');
require('./components/mainjs');
require('./components/mobileMenu');
require('./components/product');
require('./components/productSelect');
require('./components/rangeTable');
require('./components/ranges');
require('./components/specifications');

// Scripts
import analytics from './analytics/analytics.js';

/**
 * Load ES6 modules dynamically
 **/
import moduleLoader from './module-loader';

// Mock Services
// async function makeServer() {
//   const { default: server } = await import('@/api/server');
//   server();
// }
// if (process.env.NODE_ENV === 'development') {
//   makeServer();
// }

document.addEventListener(
  'DOMContentLoaded',
  () => {
    const modules = Array.from(document.querySelectorAll('[data-module]'));
    moduleLoader(modules);

    //Scripts
    analytics();
  },
  false,
);
